import Contentstack from 'contentstack';
import { CMSIntegration, GetEntriesParams } from '../interfaces';

export class ContentstackIntegration implements CMSIntegration {
  private client: Contentstack.Stack;

  constructor() {
    this.client = Contentstack.Stack({
      api_key: process.env.CS_STACK_API_KEY,
      delivery_token: process.env.CS_DELIVERY_TOKEN,
      environment: process.env.CS_ENV,
      branch: process.env.CS_BRANCH
    });
  }

  getEntriesByContentType = async <T>(contentTypeId: string, params?: GetEntriesParams): Promise<[[T]]> => {
    let query: Contentstack.Query = this.client.ContentType(contentTypeId).Query();
    if (params?.limit) {
      query = query.limit(params.limit);
    }
    if (params?.fieldsToExpand) {
      query = query.includeReference(params.fieldsToExpand);
    }
    if (params?.onlyFieldsToGet) {
      query = query.only(params.onlyFieldsToGet);
    }
    if (params?.filter?.length) {
      params.filter.forEach(filter => {
        query = query.containedIn(filter.fieldName, filter.values);
      });
    }
    const result = await query.toJSON().find();

    return result as [[T]];
  };
}
